import { startLoading, endLoading } from '../../../app-dux/app-dux';
import recognitionService from '../../../services/recognition';
import * as types from './types';

export const setProgamsAndRewards = prs => ( { type: types.SET_PROGRAMS_AND_REWARDS, prs } );
export const setSelectedBehavior = behavior => ( { type: types.SET_SELECTED_BEHAVIOIR, behavior } );
export const setSelectedProgram = selectedProgram => ( { type: types.SET_SELECTED_PROGRAM, selectedProgram } );
export const searchProgramsAndRewardChoices = () => dispatch => {
    dispatch( startLoading() );
    return recognitionService.searchProgramsAndRewardChoices( { contentFetchingLocale: 'en-US' } ).then(
        results => {
            dispatch( setProgamsAndRewards( results.rewardChoices ) );
            dispatch( endLoading() );
        }
    ).catch( ( error ) => {
        dispatch( endLoading() );
        console.error( error );
    } );
};